import React, {useState} from "react";
import GenericDialog from "@common/GenericDialog";
import {Form, Input, Radio} from "antd";
import axios from "@common/axios";

const EditTaskDialog = props => {
    const {open, data, onClose, callback} = props;
    const [form] = Form.useForm();
    const [submittable, setSubmittable] = useState(true);

    return (
        <GenericDialog
            title="Edit task details"
            open={open}
            contentStyle={{
                width: 480,
                height: 280,
            }}
            onClose={onClose}
            buttons={[
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                },
                {
                    name: "Update",
                    disabled: !submittable,
                    callback: async () => {
                        try {
                            setSubmittable(false);

                            const values = await form.validateFields();
                            if (!values) return false;

                            const formData = new URLSearchParams();
                            Object.keys(values).forEach(key => {
                                formData.append(`pathway.${key}`, values[key]);
                            });

                            const response = await axios.post("/trail/updateTrailDetails.action", formData, {
                                headers: { "Content-Type": "application/x-www-form-urlencoded"},
                            });
                            if (response.data?.success) {
                                if (callback && typeof callback === "function") callback(response.data);
                                onClose();
                            } else {
                                console.error("Server response unsuccessful:", response.data);
                                displayToastMessage("Update failed", null, "error", undefined, 4000);
                            }
                        } catch (error) {
                            if (error instanceof Error) {
                                console.error("Form submission error:", error.message);
                                displayToastMessage("Update failed", null, "error", undefined, 4000);
                            }
                        } finally {
                            setSubmittable(true);
                        }
                    },
                },
            ]}
        >
            <Form
                form={form}
                className="ch-form padding--m margin-b--rm"
                layout="vertical"
                initialValues={data}
            >
                <Form.Item
                    name="pathwayId"
                    noStyle
                >
                    <Input type="hidden" />
                </Form.Item>
                <Form.Item
                    label="Task name"
                    name="pathwayName"
                    rules={[{
                        required: true,
                        message: "Please input a task name."
                    }]}>
                    <Input placeholder={"Task name"}/>
                </Form.Item>
                <Form.Item
                    label="Type"
                    name="pathwayType"
                >
                    <Radio.Group
                        optionType="button"
                        disabled={true}
                        options={[
                            {label: "Task", value: 'TASK'},
                            {label: "Template", value: 'PATHWAY'},
                        ]}
                    />
                </Form.Item>
                <Form.Item
                    label="Description"
                    name="description"
                >
                    <Input.TextArea
                        placeholder="This section can only be seen by teachers."
                        showCount
                        maxLength={230}
                    />
                </Form.Item>
            </Form>
        </GenericDialog>
    )
}

export default EditTaskDialog;